import React from 'react';
import { Register } from '../factory';
import { DatePicker } from 'antd-mobile';
import { dateFormat } from '../../../utils';

@Register({ name: 'dy-datepicker' })
class DyDatepicker extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleChange = val => {
        const { type } = this.props;
        if (type === 'year') {
            this.props.onChange(dateFormat(val, 'YYYY'));
        } else if (type === 'month') {
            this.props.onChange(dateFormat(val, 'YYYY-MM'));
        } else if (type === 'date') {
            this.props.onChange(dateFormat(val, 'YYYY-MM-DD'));
        } else {
            this.props.onChange(dateFormat(val, 'YYYY-MM-DD hh:mm'));
        }
    };

    render() {
        let { className, name, value, type } = this.props;
        let dateValue: Date;

        if (type === 'year') {
            dateValue = new Date(value, 1, 1);
        } else if (type === 'month') {
            dateValue = new Date(value.replace(/\-/g, '/') + '/1');
        } else if (type === 'date') {
            dateValue = new Date(value.replace(/\-/g, '/'));
        } else {
            dateValue = new Date(value.replace(/\-/g, '/'));
        }

        return (
            <div className={`dy-fm-item ${className ? className : ''}`}>
                <DatePicker mode={type} value={value ? dateValue : new Date()} minDate={new Date(1900, 1, 1)} onOk={this.handleChange}>
                    <div className={`dy-fm-item-pick-view ${value ? 'edited' : ''}`}>{value ? value : '请选择时间'}</div>
                </DatePicker>
            </div>
        );
    }
}

export default DyDatepicker;
